<template>
  <div>
    <template v-if="loaded && !loadError">
      <div :class="{'wrapper': !inquiryID }">
        <div
          v-if="!inquiryID"
          class="card flex-row is-smallshadow mt-2 py-2 px-2 width-medium mx-auto">
          <f-button
            class="text-uppercase pr-1-sm"
            theme="go-back"
            withArrow
            withArrowBackwards
            @click.prevent="$router.push(routeBack)">
            {{ $t('messageForm.backToMessagesList') }}
          </f-button>

          <f-button
            v-if="!data.is_archived && loaded"
            class="ml-auto"
            theme="text"
            @click.prevent="archiveTopic">
            <f-icon name="archive" class="mr-0-xs" />
            <span class="hidden-mobile-tiny">{{ $t('ui.archive') }}</span>
          </f-button>
        </div>

        <f-alert
          v-if="data.is_archived && loaded"
          class="my-2 width-medium mx-auto"
          theme="warning"
          visible
          small>
          {{ $t('message.topic.archiveTopicSuccessTitle') }}
        </f-alert>

        <div class="card is-smallshadow mt-2 mb-5 width-medium mx-auto">
          <div
            v-if="!inquiryID"
            class="card-header py-2 px-3">
            <h2 class="heading-tiny text-light flex flex-align-items-center">
              <template v-if="data.inquiry_id">
                <span>
                  {{ $t('messagesList.numberOfOffer') }} {{ data.inquiry_id }}
                </span>
                <f-button
                  class="ml-auto pr-0-md"
                  type="submit"
                  theme="text-light"
                  @click.prevent="$router.push('/oferty-kredytowe/' + data.inquiry_id)">
                {{ $t('messageForm.offerPreview') }}
                </f-button>
              </template>
              <template v-else>
              {{ $t('messagesList.directMessage') }}
              </template>
            </h2>
          </div>

          <div class="card-body px-3 pt-2">
            <div class="border-bottom pb-3">
              <template v-if="userType === 'adviser'">
                <h3 class="heading-medium flex flex-align-items-center flex-justify-content-between full-width message-header">
                  <span>{{ data.customer_name }} {{ data.customer_surname }}</span>
                  <span
                    v-if="data.id"
                    class="small">
                    {{ $t('messageForm.numberOfCall') }}: {{ data.id }}
                  </span>
                </h3>
                <a
                  v-if="data.customer_city"
                  href="#"
                  class="lnk lnk-contact mr-3 mb-1 full-width-ms mr-0-sm">
                  <f-icon name="map-pin" />
                  {{ data.customer_city }}
                </a>
                <a
                  v-if="data.customer_phone"
                  :href="'tel:' + removeSpacesFromString(data.customer_phone)"
                  class="lnk lnk-contact mr-3 mb-1 full-width-ms mr-0-sm">
                  <f-icon name="phone" />
                  {{ data.customer_phone }}
                </a>
                <a
                  v-if="data.customer_email"
                  :href="'mailto:' + data.customer_email"
                  class="lnk lnk-contact mb-1 full-width-ms mr-0-sm">
                  <f-icon name="mail" />
                  {{ data.customer_email }}
                </a>
              </template>
              <template v-else>
                <h3 class="heading-medium flex flex-align-items-center flex-justify-content-between full-width message-header">
                  <template v-if="data.adviser_id">
                    <span>{{ data.adviser_name }} {{ data.adviser_surname }}</span>
                  </template>
                  <template v-else>
                    <span>{{ $t('messageForm.noAssignedExpert') }}</span>
                  </template>
                  <span
                    v-if="data.id"
                    class="small">
                    {{ $t('messageForm.numberOfCall') }}: {{ data.id }}
                  </span>
                </h3>
                <a
                  v-if="data.adviser_city"
                  href="#"
                  class="lnk lnk-contact mr-3 mb-1 full-width-ms mr-0-sm">
                  <f-icon name="map-pin" />
                  {{ data.adviser_city }}
                </a>
                <a
                  v-if="data.adviser_phone"
                  :href="'tel:' + removeSpacesFromString(data.adviser_phone)"
                  class="lnk lnk-contact mr-3 mb-1 full-width-ms mr-0-sm">
                  <f-icon name="phone" />
                  {{ data.adviser_phone }}
                </a>
                <a
                  v-if="data.adviser_email"
                  :href="'mailto:' + data.adviser_email"
                  class="lnk lnk-contact mb-1 full-width-ms mr-0-sm">
                  <f-icon name="mail" />
                  {{ data.adviser_email }}
                </a>
              </template>
            </div>
            <f-message-history
              class="mt-3"
              :items="messageFormatted"/>

            <template v-if="!data.is_archived">
              <validation-observer
                ref="conversation-form"
                tag="form"
                class="border-top pt-4 mt-4">
                <div class="form-group mb-0">
                  <label for="message">{{ $t('messageForm.writeTheMessage') }}: </label>

                  <validation-provider
                    tag="div"
                    rules="required|max:2000"
                    name="message"
                    v-slot="{ errors }">
                    <f-textarea
                      v-model="newMessage"
                      :maxLength="200"
                      :showCounter="true"
                      :rows="6"
                      :state="errors.length ? 'invalid' : null"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </validation-observer>

              <div class="flex mt-2 ">
                <div>
                  <f-file-input
                    id="topicAttachment"
                    :label="$t('messageForm.addAttachment')"
                    icon="attachment"
                    accept=".pdf, .jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx"
                    :multiple="true"
                    :onChange="attachFiles"/>
                </div>

                <f-button
                  class="ml-auto"
                  :disabled="actionInProgress || !newMessage || !newMessage.length"
                  theme="primary"
                  withArrow
                  big
                  @click.prevent="validateForm">
                  {{ $t('ui.send') }}
                </f-button>
              </div>

              <div
                v-if="files.length"
                class="flex flex-column mt-2 attach-files-list full-width">
                <span class="heading-tiny mb-2">{{ $t('messageForm.attachedFiles') }}:</span>
                <span
                  v-for="(file, index) of files"
                  :key="index"
                  class="attach-files-list-item">
                  <div class="mr-3 mb-2">
                    <label>{{ $t('messageForm.fileName') }}</label>
                    {{ file.name }}
                  </div>
                  <label>{{ $t('messageForm.descriptionFile') }}</label>
                  <f-textarea
                    fullWidth
                    v-model="descriptions[index]"
                    :rows="2"/>

                  <f-button
                    class="ml-auto mt-2 block"
                    theme="danger"
                    :disabled="actionInProgress"
                    @click.prevent="removeFile(index)">
                    {{ $t('messageForm.deleteFile') }}
                  </f-button>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-if="!loaded && !loadError"
        class="loading-spinner-wrapper">
        <div class="loading-spinner pb-3 pt-3">
          <span class="loading-spinner-content">
            {{ $t('ui.loadingDataInProgress') }}&hellip;
          </span>
        </div>
      </div>
      <div class="wrapper mt-3">
        <f-alert
          v-if="loadError"
          theme="warning"
          visible>
          <span>
            {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
        </span>
        </f-alert>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import MessagesUtils from '@/utils/MessagesUtils.js';

export default {
  name: 'message-form',
  props: {
    inquiryID: {
      type: Number,
      default: 0
    },
    inquiryMessagesTopicID: {
      type: Number,
      default: 0
    },
    customerName: {
      type: String,
      default: ''
    },
    customerSurname: {
      type: String,
      default: ''
    },
    customerEmail: {
      type: String,
      default: ''
    },
    customerPhone: {
      type: String,
      default: ''
    },
    customerCity: {
      type: String,
      default: ''
    },
    inquiryAdviser: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isEdit () {
      return !!this.$route.params.id;
    },
    messageFormatted () {
      return this.data.messages.map(item => {
        if (this.userType === 'adviser') {
          item.author = this.$t('messageForm.myMessage');
          if (item.user_id === this.data.adviser_id) {
            item.isFromCurrentUser = true;
          } else {
            item.author = this.data.customer_name + ' ' + this.data.customer_surname;
          }
        } else {
          item.author = this.data.adviser_name + ' ' + this.data.adviser_surname;
          if (item.user_id === this.data.customer_id) {
            item.isFromCurrentUser = true;
            item.author = this.$t('messageForm.myMessage');
          }
        }

        item.downloadFileEndpoint = '/api/messages/download-file/';

        return item;
      });
    },
    routeBack () {
      let routeArray = this.$route.path.split('/');
      routeArray.pop();
      return routeArray.join('/');
    }
  },
  data() {
    return {
      data: {
        id: 0,
        inquiry_id: 0,
        adviser_id: 0,
        adviser_name: '',
        adviser_surname: '',
        adviser_email: '',
        adviser_phone: '',
        adviser_city: '',
        customer_id: 0,
        customer_name: '',
        customer_surname: '',
        customer_email: '',
        customer_phone: '',
        customer_post_code: '',
        customer_city: '',
        is_archived: false,
        messages: []
      },
      loaded: false,
      loadError: false,
      newMessage: '',
      files: [],
      descriptions: [],
      userType: null,
      actionInProgress: false
    };
  },
  mounted () {
    this.$bus.$on('mark-message-as-read', this.triggerMarkAsRead);
    if (this.inquiryID) {
      this.data.inquiry_id = this.inquiryID;
    }

    this.userType = this.$store.getters['getUserType'].toLowerCase();

    if ((this.inquiryID && this.inquiryMessagesTopicID) || (!this.inquiryID && this.isEdit)) {
      this.loadItemData(this.inquiryMessagesTopicID);

      return;
    }

    Vue.set(this.data, 'customer_name', this.customerName);
    Vue.set(this.data, 'customer_surname', this.customerSurname);
    Vue.set(this.data, 'customer_email', this.customerEmail);
    Vue.set(this.data, 'customer_phone', this.customerPhone);
    Vue.set(this.data, 'customer_city', this.customerCity);

    if (this.inquiryAdviser) {
      Vue.set(this.data, 'adviser_id', this.inquiryAdviser.id);
      Vue.set(this.data, 'adviser_name', this.inquiryAdviser.name);
      Vue.set(this.data, 'adviser_surname', this.inquiryAdviser.surname);
      Vue.set(this.data, 'adviser_email', this.inquiryAdviser.email);
      Vue.set(this.data, 'adviser_phone', this.inquiryAdviser.phone);
      Vue.set(this.data, 'adviser_city', this.inquiryAdviser.city);
    }

    this.loaded = true;
  },
  methods: {
    loadItemData (topicID) {
      FormUtils.loadItemData(this, {
        id: topicID,
        method: 'get',
        endpointBase: '/api/messages/topics/item/',
        instanceFields: [
          'id',
          'inquiry_id',
          'adviser_id',
          'adviser_name',
          'adviser_surname',
          'adviser_email',
          'adviser_phone',
          'adviser_city',
          'customer_id',
          'customer_name',
          'customer_surname',
          'customer_email',
          'customer_phone',
          'customer_post_code',
          'customer_city',
          'is_archived',
          'messages'
        ],
        loadedKey: 'loaded',
        successAction: () => {
          Vue.nextTick(() => {
            let isPathInquiry = this.$route.matched.find(item => item.path === '/oferty-kredytowe/:id');

            if (this.isEdit && !isPathInquiry) {
              this.triggerMarkAsRead();
            }

            setTimeout(() => {
              this.$bus.$emit('update-messages-count', true);
            }, 1000);
          })
        }
      });
    },
    submitForm () {
      this.actionInProgress = true;
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/api/messages/store';

      let fileParams = [];
      if (formDataToSend.files && formDataToSend.files.length) {
        fileParams.push('files');
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('registerMailSent.sendMessage'),
        successText: this.$t('messageForm.messageWasSendInThread'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('messageForm.sendMessageError'),
        successAction: (response) => {
          this.actionInProgress = false;
          this.clearForm();
          Vue.nextTick(() => {
            this.loadItemData(response.item.topic.id);
          })
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      }, fileParams);
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        message: this.newMessage,
      };

      if (this.data.inquiry_id) {
        formDataToSend.inquiry_id = this.data.inquiry_id;
      }

      if (this.data.id) {
        formDataToSend.topic_id = this.data.id;
      }

      if (this.files.length) {
        formDataToSend.files = [];

        for (let i = 0; i < this.files.length; i++) {
          formDataToSend.files.push(this.files[i]);
        }
      }

      if (this.descriptions) {
        formDataToSend.descriptions = [];

        for (let i = 0; i < this.descriptions.length; i++) {
          if (this.descriptions[i]) {
            formDataToSend.descriptions.push(this.descriptions[i]);
          } else {
            formDataToSend.descriptions.push('');
          }
        }
      }

      return formDataToSend;
    },
    validateForm () {
      FormUtils.validate(this.$refs['conversation-form'], this.submitForm);
    },
    archiveTopic () {
      MessagesUtils.archiveTopic(this.data, this, {
        successAction: () => {
          this.loadItemData(this.data.id);
        }
      });
    },
    attachFiles (event) {
      this.files.push(event.target.files[0]);
    },
    removeFile (index) {
      this.files.splice(index, 1);
    },
    clearForm() {
      this.newMessage = '';
      this.files = [];
      this.descriptions = [];
      this.$refs['conversation-form'].reset();
    },
    triggerMarkAsRead () {
      if (this.data.id) {
        MessagesUtils.markAsReadTopic(this.data.id, this);
      }
    },
    removeSpacesFromString (str) {
      if (!str) {
        return '';
      }

      return str.replace(/\s/g, '');
    }
  },
  beforeDestroy () {
    this.$bus.$off('mark-message-as-read', this.triggerMarkAsRead);
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.attach-files-list {
  &-item {
    display: block;
    margin-bottom: 3px;

    .f-btn {
      margin-left: 7px;
      position: relative;
      top: -3px;
    }
  }
}

.heading-medium,
.heading-medium > .small {
  margin-bottom: 9px;
}

@media screen and (max-width: $media-phone-l) {
  .message-header {
    align-items: flex-start!important;
    flex-direction: column;

    & > span {
      order: 2;
    }

    & > .small {
      order: 1;
    }
  }
}


</style>
